@for (group of messageGroups(); track trackByGroupDate($index, group)) {
  <div class="date-separator or-d-flex or-justify-content-center">
    <span class="or-text-sm or-color-secondary-2">{{ group.date }}</span>
  </div>

  @for (message of group.messages; track trackByMessageId($index, message); let i = $index) {
    @if (message.id === firstUnreadMessageId()) {
      <div class="unread-separator or-d-flex or-align-items-center">
        <div class="unread-separator__line"></div>
        <span class="unread-separator__text or-text-sm">Nowe wiadomości</span>
        <div class="unread-separator__line"></div>
      </div>
    }
    <lib-message-item [message]="message" [position]="getMessagePosition(group.messages, i)"> </lib-message-item>
  }
}
<div #scrollAnchor></div>
